import stream from "stream";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { writeFileSync, readFileSync } from "fs";
import { execSync, spawnSync } from "child_process";
import fs from "fs";
import rp from "request-promise";
import axios from "axios";
import moment from "moment-timezone";

export default class Util {
  static OFFICE_SERVER_URL = "https://gitlab.com/";
  static TIMEZONE = "Australia/Melbourne";
  static round(num) {
    return Number(Math.round(num + "e2") + "e-2");
  }

  static dollarToNumeric(dollarAmount) {
    let num = dollarAmount.substring(1);
    return num;
  }

  static calculateDistance(position1, position2) {
    const R = 6378.137;
    let lat1 = position1.latitude;
    let lat2 = position2.latitude;
    let lon1 = position1.longitude;
    let lon2 = position2.longitude;
    let dLat = ((lat2 - lat1) * Math.PI) / 180;
    let dLon = ((lon2 - lon1) * Math.PI) / 180;
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let distance = R * c * 1000;
    return distance;
  }

  static parseQuery(form, models) {
    let _ = require("lodash");
    let moment = require("moment-timezone");
    const ZONE = "Australia/Melbourne";
    let where = {};
    let modelWheres = {};
    let having = false;
    form.forEach(function({ name, value, type, object, objectType }) {
      // prevent searches with empty strings
      if (typeof value === "string" && value.replace(/\s/gi, "").length === 0) {
        return false;
      }
      if (
        value ||
        type === "object" ||
        (type === "date-range" && value && (value.endDate || value.startDate))
      ) {
        switch (type) {
          case "search":
            if (name === "quoteReferenceNumber") {
              where.number = value.match(/\d+/)[0];
            } else if (name === "fullName") {
              let names = value.split(" ", 2);
              if (names[1]) {
                where.fullName = { $iLike: `${value}%` };
              } else {
                where.$or = [
                  { fullName: { $iLike: `%${names[0]}%` } },
                  { fullName: { $iLike: `%${names[0]}%` } }
                ];
              }
            } else if (name === "phone") {
              let query = "(";
              for (let c of value) {
                query = `${query}${c}\\s*`;
              }
              query += ")";
              where.phone = models.sequelize.literal(
                ` "Account"."phone" ~ '${query}' `
              );
            } else {
              where[name] = { $iLike: `${value}%` };
            }
            break;

          case "loose-search":
            where[name] = { $iLike: `%${value}%` };
            break;

          case "array":
            where[name] = {
              $or: [{ $contains: [value] }, { $contains: [_.startCase(value)] }]
            };
            break;

          case "date-range":
            if (value.startDate || value.endDate) {
              where[name] = {};
            }
            if (value.startDate) {
              where[name].$gte = moment(value.startDate)
                .tz(ZONE)
                .format();
            }
            if (value.endDate) {
              where[name].$lte = moment(value.endDate)
                .tz(ZONE)
                .format();
            }
            break;

          case "calendar":
            if (value) {
              where[name] = {
                $gte: moment(value)
                  .set({ hour: 0, minute: 0, second: 0 })
                  .tz(ZONE)
                  .format(),
                $lte: moment(value)
                  .set({ hour: 23, minute: 59, second: 59 })
                  .tz(ZONE)
                  .format()
              };
            }
            break;

          case "object":
            if (!modelWheres[object]) modelWheres[object] = {};
            if (value) {
              if (objectType === "search") {
                if (name === "fullName") {
                  let names = value.split(" ", 2);
                  if (names[1]) {
                    modelWheres[object].fullName = { $iLike: `${value}%` };
                  } else {
                    modelWheres[object].$or = [
                      { fullName: { $iLike: `${names[0]}%` } },
                      { fullName: { $iLike: `${names[0]}%` } }
                    ];
                  }
                } else if (name === "staffMemberFullName"){
                  modelWheres[object].fullName = {$iLike: `%${value}%`};
                } else {
                  modelWheres[object][name] = {
                    $iLike: `%${value}%`
                  };
                }
              } else if (objectType === "loose-search") {
                modelWheres[object][name] = { $iLike: `%${value}%` };
              } else {
                modelWheres[object][name] = value;
              }
            }
            break;

          case "relation":
            if (!modelWheres[object]) modelWheres[object] = {};
            if (value) {
              if (objectType === "search") {
                if (name === "fullName") {
                  let names = value.split(" ", 2);
                  if (names[1]) {
                    modelWheres[object].fullName = { $iLike: `${value}%` };
                  } else {
                    modelWheres[object].$or = [
                      { fullName: { $iLike: `${names[0]}%` } },
                      { fullName: { $iLike: `${names[0]}%` } }
                    ];
                  }
                } else {
                  modelWheres[object][name] = {
                    $iLike: `${value}%`
                  };
                }
              } else {
                modelWheres[object][name] = value;
              }
            }
            break;

          case "boolean":
            if (name === "hasReservation") {
              if (!/^false/i.test(value)) {
                where.ReservationUuid = { $ne: null };
              } else {
                where.ReservationUuid = null;
              }
            } else if (name === "baysAvailable") {
              if (!/^false/i.test(value)) {
                // bays available
                having = {
                  bays: {
                    $gt: models.sequelize.fn(
                      "COUNT",
                      models.sequelize.col("Cars")
                    )
                  }
                };
              } else {
                // bays not available
                having = {
                  bays: {
                    $lte: models.sequelize.fn(
                      "COUNT",
                      models.sequelize.col("Cars")
                    )
                  }
                };
              }
            } else if (name === "assigned") {
              if (!/^false/i.test(value)) {
                where.AccountUuid = { $ne: null };
              } else {
                where.AccountUuid = null;
              }
            } else if (name === "deleted") {
              if (!/^false/i.test(value)) {
                where.deletedAt = { $ne: null };
              } else {
                where.deletedAt = null;
              }
            } else {
              where[name] = !/^false/i.test(value);
            }
            break;

          case "checkboxes":
            modelWheres[object] = value;
            break;

          case "number":
            if (name === "modelReservationId") {
              modelWheres["Reservation"] = {
                reservationId: value
              };
            } else {
              where[name] = value;
            }
            break;

          case "radio":
            switch (name) {
              case "assignmentStatus":
                // Only set assignment status if QuoteAssignedToUuid is not set
                if (!form.find(f => f.name === 'QuoteAssignedToUuid' && f.value)) {
                  if (value === "true") {
                    modelWheres["Quote"] = {
                      ...modelWheres["Quote"],
                      QuoteAssignedToUuid: { [models.sequelize.Op.ne]: null }
                    };
                  } else if (value === "false") {
                    modelWheres["Quote"] = {
                      ...modelWheres["Quote"],
                      QuoteAssignedToUuid: null
                    };
                  }
                }
                break;
              case "completed":
                if (value === "true") {
                  modelWheres["Quote"] = {
                    ...modelWheres["Quote"],
                    completed: true
                  };
                } else if (value === "false") {
                  modelWheres["Quote"] = {
                    ...modelWheres["Quote"],
                    completed: false
                  };
                }
                break;
              default:
                where[name] = value;
                break;
            }
            break;
          default:
            where[name] = value;
            break;
        }
      }
    });
    return { where, modelWheres, having };
  }

  /**
   * @desc takes 2 sets of lat/lng and calculates the mid point
   * @returns latitude and longitude for the mid point
   **/
  static middlePoint(lat1, lng1, lat2, lng2) {
    let dLng = ((lng2 - lng1) * Math.PI) / 180;
    lat1 = (lat1 * Math.PI) / 180;
    lat2 = (lat2 * Math.PI) / 180;
    lng1 = (lng1 * Math.PI) / 180;
    let bX = Math.cos(lat2) * Math.cos(dLng);
    let bY = Math.cos(lat2) * Math.sin(dLng);
    let lat3 = Math.atan2(
      Math.sin(lat1) + Math.sin(lat2),
      Math.sqrt((Math.cos(lat1) + bX) * (Math.cos(lat1) + bX) + bY * bY)
    );
    let lng3 = lng1 + Math.atan2(bY, Math.cos(lat1) + bX);
    return { lng: lng3 * (180 / Math.PI), lat: lat3 * (180 / Math.PI) };
  }

  static getExtension(mimetype) {
    switch (mimetype) {
      case "image/jpeg":
        return "jpg";
      case "image/png":
        return "png";
      case "image/gif":
        return "gif";
      case "application/pdf":
      case "application/x-pdf":
        return "pdf";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return "xlsx";
      case "video/webm":
        return "webm";
      case "video/mp4":
        return "mp4";
      case "video/quicktime":
        return "mov";
      case "video/avi":
        return "avi";
      case "video/x-ms-wmv":
        return "wmv";
      case "audio/ogg":
        return "ogg";
      case "audio/mp3":
        return "mp3";
      default:
        return false;
    }
  }

  static getMimetype(extension) {
    switch (extension) {
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "gif":
        return "image/gif";
      case "pdf":
        return "application/pdf";
      default:
        return false;
    }
  }

  /**
   * @desc Determines whether the uuid is valid, converting it from a buffer if necessary.
   *
   * @param  {String}  uuid
   * @return {Boolean}
   **/
  static isUuid(uuid) {
    if (!uuid) {
      return false;
    }
    let pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-4][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    uuid = uuid.toLowerCase();
    return pattern.test(uuid);
  }

  /**
   *  @desc Returns Google geocoded components of an input address
   *
   * @param  {String}  address
   * @return {Object}  address components
   **/
  static async geocode(address) {
    let result = {
      postcode: "",
      suburb: "",
      state: "",
      country: "",
      municipality: "",
      streetNumber: "",
      streetName: "",
      subpremise: "",
      lat: 0,
      lng: 0
    };
    if (!address) return result;
    let rp = require("request-promise");
    address = address.replace(/\s/g, "+");
    let options = {
      uri: "https://maps.googleapis.com/maps/api/geocode/json",
      qs: {
        address: address,
        key: "AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c"
      },
      json: true
    };
    let geocode = await rp(options);
    if (geocode.status === "OK") {
      result.lat = geocode.results[0].geometry.location.lat;
      result.lng = geocode.results[0].geometry.location.lng;
      geocode.results[0].address_components.forEach(function(component) {
        if (component.types.includes("postal_code")) {
          result.postcode = component.short_name;
        }
        if (component.types.includes("locality")) {
          result.suburb = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          result.state = component.short_name;
        }
        if (component.types.includes("country")) {
          result.country = component.long_name;
        }
        if (component.types.includes("administrative_area_level_2")) {
          result.municipality = component.short_name;
        }
        if (component.types.includes("street_number")) {
          result.streetNumber = component.long_name;
        }
        if (component.types.includes("route")) {
          result.streetName = component.long_name;
        }
        if (component.types.includes("subpremise")) {
          result.subpremise = component.long_name;
        }
      });
    }
    return result;
  }

  static async saveFile(options, models) {
    let opts = { ...options };
    let finalKey = opts.key.replace("tmp", "data");
    if (opts.key && opts.key !== finalKey) {
      try {
        await opts.s3
          .copyObject({
            Bucket: opts.bucket,
            CopySource: `${opts.bucket}/${opts.key}`,
            Key: finalKey,
            ACL: "public-read",
            MetadataDirective: "REPLACE"
          })
          .promise();
        let attachment = await models.Attachment.create({
          objectKey: finalKey,
          fileType: opts.fileType,
          fileName: opts.fileName
        });
        return attachment;
      } catch (err) {
        throw err;
      }
    } else {
      throw new Error(opts.key + " has already been saved.");
    }
  }

  static addVideoBoxes(videos) {
    let videoHtml = "";
    if (videos && videos.length) {
      videoHtml = '<div class="group"><h2 class="title">Video</h2></div>';
      if (videos.length === 1) {
        videoHtml += `<div class="group">
        <table class="video-table">
          <tr>
            <td class="videoBox" align="center" valign="top">
              ${videos[0]}
            </td>
          </tr>
        </table>
      </div>`;
      } else {
        for (let i = 0; i < videos.length - 1; i += 2) {
          videoHtml += `<div class="group">
          <table class="video-table">
            <tr>
              <td class="videoBox"  align="center" valign="top">
                ${videos[i]}
              </td>
              <td class="videoBox"  align="center" valign="top">
                ${videos[i + 1]}
              </td>
            </tr>
          </table>
        </div>`;
        }
        if (videos.length % 2 === 1) {
          videoHtml += `<div class="group">
            <table class="video-table">
              <tr>
                <td class="videoBox" align="center" valign="top">
                  ${videos[videos.length - 1]}
                </td>
              </tr>
            </table>
          </div>`;
        }
      }
    }
    return videoHtml;
  }

  static addPropertyPhotos(photos, s3Url) {
    let imageHtml = "";
    if (photos) {
      if (photos.length === 1) {
        imageHtml += `<div class="group">
        <div class="property-photos">
          <img height="350" src="${s3Url}${photos[0].objectKey}">
        </div>
      </div>`;
      } else {
        for (let i = 0; i < photos.length - 1; i += 2) {
          imageHtml += `<div class="group">
          <div class="property-photos">
            <img height="350" src="${s3Url}${photos[i].objectKey}">
            <img height="350" src="${s3Url}${photos[i + 1].objectKey}">
          </div>
        </div>`;
        }
        if (photos.length % 2 === 1) {
          imageHtml += `<div class="group">
          <div class="property-photos">
            <img height="350" src="${s3Url}${
            photos[photos.length - 1].objectKey
          }">
          </div>
        </div>`;
        }
      }
    }
    return imageHtml;
  }
  // Convert Next line to break tag
  static nl2br(str) {
    let breakTag = "<br />";
    return (str + "").replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      "$1" + breakTag + "$2"
    );
  }

  static async getApplication(models, appType) {
    let _ = require("lodash");
    if (appType === "PropertyPhotosReport") appType = "PropertyPhotos";
    if (appType === "OhsReport") appType = "OH&S Report";
    if (appType === "DefectsReport") appType = "Defect Report";
    let application = await models.Application.findOne({
      where: {
        name: {
          $or: [
            { $iLike: "%" + _.startCase(appType) + "%" },
            { $iLike: "%" + appType + "%" }
          ]
        }
      },
      attributes: ["uuid"]
    });
    return application;
  }

  static async applicationSettings(models, appType) {
    let application = await this.getApplication(models, appType);
    if (!application) {
      throw new Error("No Application Settings Found For: " + appType);
    }
    let appSettings = await models.AppSetting.findOne({
      where: {
        ApplicationUuid: application.uuid
      },
      include: [
        {
          model: models.Attachment,
          as: "EmailHeroImage"
        },
        models.EmailTemplate,
        models.InvoiceAccountCode,
        models.Application
      ]
    });
    return appSettings;
  }

  static generateFileName() {
    let crypto = require("crypto");
    let cryptoPromise = new Promise((resolve, reject) => {
      crypto.randomBytes(16, function(err, raw) {
        if (err) reject(err);
        let name = raw.toString("hex");
        resolve(name);
      });
    });
    return cryptoPromise;
  }

  static ensureExists(path, mask, cb) {
    let fs = require("fs");
    if (typeof mask === "function") {
      cb = mask;
      mask = "0777";
    }
    fs.mkdir(path, mask, function(err) {
      if (err) {
        if (err.code === "EEXIST") cb(null);
        // ignore the error if the folder already exists
        else cb(err); // something else went wrong
      } else cb(null); // successfully created folder
    });
  }

  static writeFile(path, data) {
    let fs = require("fs");
    let promise = new Promise((resolve, reject) => {
      fs.writeFile(path, data, err => {
        if (err) reject(err);
        resolve("file saved");
      });
    });
    return promise;
  }

  static uploadStream({ Bucket, Key, s3 }) {
    const pass = new stream.PassThrough();
    return {
      writeStream: pass,
      promise: s3
        .upload({
          Bucket,
          Key,
          Body: pass,
          ACL: "public-read",
          ContentType: "pdf/application"
        })
        .promise()
    };
  }

  static readFile(path, encoding) {
    let fs = require("fs");
    let promise = new Promise((resolve, reject) => {
      if (encoding) {
        fs.readFile(path, encoding, function(err, data) {
          if (err) reject(err);
          resolve(data);
        });
      } else {
        fs.readFile(path, function(err, data) {
          if (err) reject(err);
          resolve(data);
        });
      }
    });
    return promise;
  }

  static randomColour(alpha) {
    if (!alpha) alpha = 1;
    const BIT_DEPTH = 255;
    let red = Math.round(Math.random() * BIT_DEPTH);
    let green = Math.round(Math.random() * BIT_DEPTH);
    let blue = Math.round(Math.random() * BIT_DEPTH);
    return "rgba(" + red + "," + green + "," + blue + "," + alpha + ")";
  }

  static businessDays(days, date, method) {
    let moment = require("moment-timezone");
    // if incorrect method is passed (or none) - then will add by default
    let signal = 1;
    if (method === "add") {
      signal = 1;
    } else if (method === "subtract") {
      signal = -1;
    }
    if (!date) {
      date = moment();
    } else {
      date = moment(date);
    }
    days = Math.abs(days);
    let d = date.clone().add(Math.floor(days / 5) * 7 * signal, "days");
    let remaining = days % 5;
    while (remaining) {
      d.add(signal, "days");
      if (d.day() !== 0 && d.day() !== 6) {
        remaining--;
      }
    }
    return d;
  }

  static convertStringToNum(excelColumn) {
    let base = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      i,
      j,
      result = 0;

    for (
      i = 0, j = excelColumn.length - 1;
      i < excelColumn.length;
      i += 1, j -= 1
    ) {
      result += Math.pow(base.length, j) * (base.indexOf(excelColumn[i]) + 1);
    }

    return result - 1;
  }

  static quoteSearchData = {
    defaultVal: {
      workOrder: "false",
      assignmentStatus: "all"
    },
    radios: {
      workOrder: [
        {
          name: "true",
          label: "Completed",
          value: "true"
        },
        {
          name: "false",
          label: "In Progress",
          value: "false"
        },
        {
          name: "all",
          label: "All",
          value: "all"
        }
      ],
      assignmentStatus: [
        {
          name: "true",
          label: "Assigned",
          value: "true"
        },
        {
          name: "false",
          label: "Not Assigned",
          value: "false"
        },
        {
          name: "all",
          label: "All",
          value: "all"
        }
      ]
    }
  };
  // async sleep
  // usage: `await sleep(1000); // pause for 1 second`
  static Sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  static ValidateEmail(inputText) {
    const mailformat = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (inputText.match(mailformat)) {
      return true;
    }
    return false;
  }

  // Ignores the first page and the very last page(roscon cover and back cover page)
  static async addPageNumberToPDF(filename) {
    if (!filename) {
      console.error(`[Util] addPageNumberToPDF: filename is null`);
      return;
    }
    console.log(`[Util]: addPageNumberToPDF: filename: ${filename}`);
    try {
      const text = `1/24`;
      const doc = await PDFDocument.load(readFileSync(filename));
      const helveticaFont = await doc.embedFont(StandardFonts.Helvetica);
      const fontSize = 10;
      const textWidth = helveticaFont.widthOfTextAtSize(text, fontSize);
      const textHeight = helveticaFont.heightAtSize(fontSize);

      const pages = doc.getPages();
      const totalPages = pages.length; // don't include the last page
      for (let i = 1; i < pages.length - 1; i++) {
        // don't edit the cover page
        const page = pages[i];
        const { width, height } = page.getSize();
        // pdf-lib place the origin on the bottom left
        const x = width - 90;
        const y = 45;
        page.moveTo(x, y);
        page.drawText(`${i + 1} of ${totalPages}`, {
          font: helveticaFont,
          size: fontSize,
          color: rgb(0.22, 0.26, 0.32) // tailwind gray-700
        });
      }
      // save file
      writeFileSync(filename, await doc.save());
    } catch (err) {
      console.error(
        `[Util] addPageNumberToPdf failed, error: ${err.message}, stack: ${err.stack}`
      );
      return;
    }
  }

  static async downloadAndConvertToDataUrl(url, mimeType) {
    const response = await axios.get(url, {
      responseType: "arraybuffer"
    });
    const imageBuffer = Buffer.from(response.data, "binary");
    const imageBase64 = imageBuffer.toString("base64");
    let defaultMimeType = "image/png"; // Adjust the MIME type based on the image format
    if (mimeType) {
      defaultMimeType = mimeType;
    }
    const dataUrl = `data:${defaultMimeType};base64,${imageBase64}`;
    return dataUrl;
  }

  static removeIdAttributeFromTag(html) {
    const cleanedHtml = html.replace(/(\s+id\s*=\s*(['"])[^'"]*?\2)/g, "");
    return cleanedHtml;
  }

  static async getNumberOfPagesPDF(filename) {
    if (!filename) {
      console.error(`[Util] getNumberOfPagesPDF filename is null`);
      return 0;
    }
    console.log(`[Util] getNumberOfPagesPDF filename ${filename}`);
    try {
      const doc = await PDFDocument.load(readFileSync(filename));
      const pages = doc.getPages();
      return pages.length;
    } catch (err) {
      console.log(
        `[Util] getNumberOfPagesPDF: cannot get number of pages, ${err.message} ${err.stack}`
      );
      return 0;
    }
  }

  /** files is an array */
  static mergePDF(files, mergedPath) {
    if (files == null || files == undefined) {
      throw new Error("Util::mergePDF First Parameter should not be null");
    }
    if (!Array.isArray(files)) {
      throw new Error(
        "Util::mergePDF first parameter must be an array of filenames(strings)"
      );
    }
    if (files.length <= 1) {
      throw new Error(
        "Util::mergePDF first parameter must have at least two elements"
      );
    }
    if (mergedPath == null || mergedPath == undefined) {
      throw new Error("Util::mergePDF second argument is null");
    }
    // console.log(`files:`);
    // console.log(files);
    // console.log("merged Path");
    // console.log(mergedPath);

    let filesArg = "";
    for (const file of files) {
      filesArg += `"${file}"`;
      filesArg += ` `;
    }
    // console.log("filesArg");
    // console.log(filesArg);
    // invoke pdfunite command line utility
    // const tmpMergedPath = path.resolve(__dirname, "./tmp/" + "output.pdf");
    const out = execSync(`which pdfunite`);
    console.log("which pdfunite");
    console.log(out.toString());
    const cmdline = `pdfunite ${filesArg} ${mergedPath}`;
    const stdout = execSync(cmdline);
    console.log(stdout);
  }

  /**
   * Calculates pro-rata amount for contracts that don't start on July 1st (standard contract start date).
   * For contracts starting July 1st, returns the full annual amount. For all other start dates,
   * calculates proportional amount from start date to June 30th of the contract year.
   * 
   * @param {string|Date} startDateInput - The contract start date as string or Date object
   * @param {number|string} annualAmount - The full annual contract amount (accepts numbers or numeric strings)
   * @returns {number} The calculated pro-rata amount rounded to 2 decimal places, or full amount if July 1st start
   * @throws {Error} When startDate is invalid, missing, or annualAmount is not a positive number
   * 
   * @example
   * // Full year contract starting July 1st
   * calculateProRata('2025-07-01', 1200); // Returns 1200 (no pro-rating)
   * 
   * // Mid-year contract starting October 1st  
   * calculateProRata('2025-10-01', 1200); // Returns ~822.47 (Oct 1 to Jun 30)
   * 
   * // Contract starting in new calendar year
   * calculateProRata('2026-02-01', 1200); // Returns ~493.15 (Feb 1 to Jun 30)
   */
  static calculateProRata(startDateInput, annualAmount) {
    // Parse the start date, handling both string and Date object inputs
    let startDate;
    if (!startDateInput) {
      throw new Error('Please provide a startDate')
    }
  
    // Handle null values first
    if (annualAmount === null || annualAmount === undefined) {
      throw new Error('annualAmount cannot be null or undefined')
    }
  
    // Convert to number if it's a string, and validate annualAmount
    const numericAmount = typeof annualAmount === 'string' ? parseFloat(annualAmount) : annualAmount;
    
    if (typeof numericAmount !== 'number' || numericAmount <= 0 || isNaN(numericAmount)) {
      throw new Error(`annualAmount must be a positive number. Received: ${annualAmount} (type: ${typeof annualAmount})`)
    }
    
    // Use the numeric version for calculations
    annualAmount = numericAmount;
  
    if (typeof startDateInput === 'string') {
      startDate = new Date(startDateInput);
    } else if (startDateInput instanceof Date) {
      startDate = startDateInput;
    } else {
      throw new Error('Invalid start date format. Expected a string or Date object.');
    }
  
    // Ensure the date is valid
    if (isNaN(startDate.getTime())) {
      throw new Error('Invalid start date provided.');
    }
  
    // Check if the start date is July 1st (comparing date components only, not time)
    const isJulyFirst = startDate.getDate() === 1 && startDate.getMonth() === 6;
  
    if (isJulyFirst) {
      return annualAmount;
    }
  
    // Set the end date to 30th June of the following year from start date
    const startYear = startDate.getFullYear();
    let endDate;
    
    // If start date is in July-December, end date is June 30 of next year
    // If start date is in January-June, end date is June 30 of same year
    if (startDate.getMonth() >= 6) { // July (6) to December (11)
      endDate = new Date(startYear + 1, 5, 30); // June 30 of next year
    } else { // January (0) to June (5)
      endDate = new Date(startYear, 5, 30); // June 30 of same year
    }
  
    // Calculate the number of days between the start date and the end date (inclusive)
    const numberOfDays = Util.calculateDaysBetweenDates(startDate, endDate);
  
    // Calculate the daily rate
    const dailyRate = annualAmount / 365;
  
    // Calculate the pro-rata amount
    const proRataAmount = numberOfDays * dailyRate;
    return parseFloat(proRataAmount.toFixed(2)); // Return as number, not string
  }

  /**
 * Subscribes a user to the Roscon MailChimp newsletter
 * @param {Object} manager - The manager object containing user details
 * @param {string} manager.fullName - The full name of the manager
 * @param {string} manager.email - Email address of the manager
 * @param {string} [manager.businessPhone] - Business phone of the manager
 * @param {string} [manager.phoneNumber] - Phone number of the manager
 * @param {string} [manager.phone] - Phone of the manager
 * @param {string} [manager.mobileNumber] - Mobile number of the manager
 * @param {string} [manager.positionTitle] - Position title of the manager
 * @param {Object} [company] - The company object containing company details
 * @param {string} [company.address] - Company address
 * @param {string} [company.suburb] - Company suburb
 * @param {string} [company.state] - Company state
 * @param {string} [company.postcode] - Company postcode
 * @param {string} [company.name] - Company name
 * @returns {Promise<void>}
 */
  static async subscribeToRosconMailChimp(manager, company = null) {
    // Split full name into first and last name
    let fName = "";
    let lName = "";
    
    if (manager.fullName.indexOf(" ") > 0) {
      fName = manager.fullName.substring(0, manager.fullName.indexOf(" "));
      lName = manager.fullName.substring(manager.fullName.indexOf(" ") + 1);
    } else {
      fName = manager.fullName;
      lName = "";
    }
    
    // Prepare data for MailChimp
    let data = {
      email_address: manager.email,
      merge_fields: {
        FNAME: fName,
        LNAME: lName,
        PHONE: manager.businessPhone || manager.phoneNumber,
        MOBILE: manager.phone || manager.mobileNumber,
        ADDRESS: company ? company.address || "" : "",
        SUBURB: company ? company.suburb || "" : "",
        STATE: company ? company.state || "" : "",
        POSTCODE: company ? company.postcode || "" : "",
        TITLE: manager.positionTitle || "",
        COMPANY: company ? company.name || "" : ""
      },
      status: "subscribed"
    };
    
    // Prepare request options
    let requestOptions = {
      uri: `https://${process.env.ROSCON_MAIL_CHIMP_SERVER_ID}.api.mailchimp.com/3.0/lists/${process.env.ROSCON_MAIL_CHIMP_LIST_ID}/members`,
      json: true,
      body: data,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${process.env.ROSCON_MAIL_CHIMP_API_KEY_NEW}`
      }
    };
    
    // Add member to Roscon mailchimp audience list 'Owners Corporation'
    try {
      await rp(requestOptions);
      return true;
    } catch (err) {
      console.log("[Util] subscribeToRosconMailChimp(): Error subscribing user to Roscon mailchimp.");
      return false;
    }
  }

  static calculateDaysBetweenDates(startDateInput, endDateInput) {
    // Parse the start date, handling both string and Date object inputs
    let startDate, endDate;

    if (typeof startDateInput === 'string') {
        startDate = new Date(startDateInput);
    } else if (startDateInput instanceof Date) {
        startDate = startDateInput;
    } else {
        throw new Error('Invalid start date format. Expected a string or Date object.');
    }

    if (typeof endDateInput === 'string') {
        endDate = new Date(endDateInput);
    } else if (endDateInput instanceof Date) {
        endDate = endDateInput;
    } else {
        throw new Error('Invalid end date format. Expected a string or Date object.');
    }

    // Ensure both dates are valid
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error('Invalid date(s) provided.');
    }

    // Calculate the number of days between the start date and end date
    const oneDay = 1000 * 60 * 60 * 24; // Milliseconds in one day
    const diffInTime = endDate.getTime() - startDate.getTime();
    const numberOfDays = Math.floor(diffInTime / oneDay);
    console.log(`Number of Days: ${numberOfDays}`);

    return numberOfDays;
}

static getHoursBetweenDates(startDateInput, endDateInput) {
    try {
        // Handle start date
        let startDate;
        if (startDateInput instanceof Date) {
            startDate = startDateInput;
        } else if (moment.isMoment(startDateInput)) {
            startDate = startDateInput.toDate();
        } else if (typeof startDateInput === 'string') {
            startDate = new Date(startDateInput);
            if (isNaN(startDate.getTime())) {
                startDate = moment(startDateInput).toDate();
            }
        } else {
            throw new Error('Invalid start date format. Expected a string, Date object, or moment object.');
        }

        // Handle end date
        let endDate;
        if (endDateInput instanceof Date) {
            endDate = endDateInput;
        } else if (moment.isMoment(endDateInput)) {
            endDate = endDateInput.toDate();
        } else if (typeof endDateInput === 'string') {
            endDate = new Date(endDateInput);
            if (isNaN(endDate.getTime())) {
                endDate = moment(endDateInput).toDate();
            }
        } else {
            throw new Error('Invalid end date format. Expected a string, Date object, or moment object.');
        }

        // Ensure both dates are valid
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            throw new Error('Invalid date(s) provided.');
        }

        const diffInTime = endDate.getTime() - startDate.getTime();
        const numberOfHours = Math.floor(diffInTime / (1000 * 60 * 60));
        return numberOfHours;
    } catch (error) {
        console.error('Error in getHoursBetweenDates:', error);
        throw new Error(`Failed to calculate hours between dates: ${error.message}`);
    }
}

  /**
   * Check if a string contains 'PS' in the beginning, if not add 'PS' to the beginning of the string
   * @param {string} word - The string to check
   * @returns {string} The string with 'PS' added to the beginning or the original string
   * @throws {Error} When word is not provided or empty
   * 
   * @example
   * addPSToString('12345'); // Returns PS12345
   * addPSToString('PS12345'); // Returns PS12345
   */
  static addPSToString(word) {
    if(!word || word.length === 0){
      console.error("Error string not provided")
      return
    }
    
    // Check if the first two letters are 'PS'
    if(word.substring(0, 2).toUpperCase() !== 'PS') {
      // If not add PS to the beginning of the string
      return 'PS' + word;
    }
    
    // Return the original word if it already starts with PS
    return word;
  }

  /**
   * Calculates the annual cost for property management services based on number of lots and service type.
   * Uses tiered pricing structure with different rates for OC Managers vs Real Estate Agents.
   * 
   * @param {number} numLots - The number of lots in the property (must be positive integer)
   * @param {boolean} [isOCManager=true] - True for OC Manager pricing, false for Real Estate Agent pricing
   * @param {boolean} [isDiscounted=false] - True to apply discounted rates (only applicable for OC Managers) 
   * (Curently only applicable to Australia Body Corporate)
   * @returns {number} The calculated annual fee rounded to 2 decimal places
   * @throws {Error} When numLots is negative or zero
   * 
   * @example
   * // Standard OC Manager pricing for 30 lots
   * calculateAnnualCost(30, true, false); // Returns 297.00
   * 
   * // Discounted OC Manager pricing for 15 lots  
   * calculateAnnualCost(15, true, true); // Returns 110.00
   * 
   * // Real Estate Agent pricing for 150 lots
   * calculateAnnualCost(150, false); // Returns 1540.00
   */
  static calculateAnnualCost(numLots, isOCManager=true, isDiscounted=false) {
    if(numLots < 0){
      throw new Error("Invalid number: numLots cannot be negative");
    }
    
    if(numLots === 0){
      throw new Error("Invalid number: numLots must be greater than 0");
    }
    
    let annualFee = 0;
    
    if(isOCManager){
      if(isDiscounted){
        if (numLots <= 10) {
          annualFee = 55;
        }
        else if(numLots >= 11 && numLots <= 25){
          annualFee = 110;
        } 
        else if (numLots >= 26 && numLots <= 50) {
          annualFee = numLots * 9.90;
        } 
        else if (numLots >= 51 && numLots <= 100) {
          annualFee = numLots * 8.80;
        } 
        else if (numLots >= 101 && numLots <= 200) {
          annualFee = numLots * 7.70;
        } 
        else if (numLots >= 201 && numLots <= 300) {
          annualFee = numLots * 6.60;
        } 
        else if (numLots >= 301) {
          annualFee = numLots * 5.50;
        }
      }
      else{
        if (numLots >= 1 && numLots <= 25) {
          annualFee = 220;
        }
        else if (numLots >= 26 && numLots <= 50) {
          annualFee = numLots * 9.90;
        } 
        else if (numLots >= 51 && numLots <= 100) {
          annualFee = numLots * 8.80;
        } 
        else if (numLots >= 101 && numLots <= 200) {
          annualFee = numLots * 7.70;
        } 
        else if (numLots >= 201 && numLots <= 300) {
          annualFee = numLots * 6.60;
        } 
        else if (numLots >= 301) {
          annualFee = numLots * 5.50;
        }
      }
    }
    // if Real Estate Agent
    else{
      if (numLots >= 1 && numLots <= 25) {
        annualFee = 440;
      } 
      else if (numLots >= 26 && numLots <= 50) {
        annualFee = 495;
      } 
      else if (numLots >= 51 && numLots <= 100) {
        annualFee = 880;
      } 
      else if (numLots >= 101 && numLots <= 200) {
        annualFee = 1540;
      } 
      else if (numLots >= 201 && numLots <= 300) {
        annualFee = 1980;
      } 
      else if (numLots >= 301) {
        annualFee = 2500;
      }
    }
    
    // Return as number, not string
    return Math.round(annualFee * 100) / 100; // Round to 2 decimal places but keep as number
  }
}



// WEBPACK FOOTER //
// ./server/util/index.js